import React from 'react'
import {UsageSummary} from '@/ui/index'
import {OrgLevelUsageSummaryItems} from '../org-level-usage/OrgLevelUsageSummaryItems'

export function UsageSummaryOrgPlanNew() {
  return (
    <UsageSummary.Container loading={false} dense columns={[1, 1, 1, 2]}>
      <OrgLevelUsageSummaryItems />
    </UsageSummary.Container>
  )
}
